import { BrandsClient, CompaniesClient, initializeClients } from 'src/common-services'
import { IS_TEST } from 'src/config'

const storage = typeof localStorage === 'undefined' ? undefined : localStorage

const getDeviceId = () => {
  if (IS_TEST) {
    return 'test'
  }
  const deviceId = storage?.getItem('deviceId')
  if (deviceId) {
    return deviceId
  }
  const id = Math.random().toString(36).substr(2, 10)
  storage?.setItem('deviceId', id)
  return id
}

const options = {
  deviceId: getDeviceId(),
}

const clients = initializeClients(options)

// Internal Clients
export const userClient = clients.user
export const signupClient = clients.signup
export const demoClient = clients.demo
export const geoClient = clients.geo
export const venueClient = clients.venue
export const footfallClient = clients.footfall
export const performanceClient = clients.performance
export const driveTimeClient = clients.driveTime
export const consumerSpendClient = clients.consumerSpend
export const tradeAreaClient = clients.tradeArea
export const crossVisitClient = clients.crossVisit
export const userListsClient = clients.userListsClient
export const loggingClient = clients.loggingClient
export const vendorsClient = clients.vendors
export const systemClient = clients.system
export const documentsClient = clients.documents
export const mockData = clients.mockData
export const trafficClient = clients.traffic
export const userFilesClient = clients.userFiles
export const brandLogosClient = clients.brandLogos
export const brandsClient = clients.brands
export const recentlyViewedClient = clients.recentlyViewed
export const reportThemesClient = clients.reportThemes
export const customFootfallClient = clients.customFootfall
export const customInsightsClient = clients.customInsights
export const customMapClient = clients.customMaps
export const placesClient = clients.places
export const pricingCalculatorClient = clients.pricingCalculator
export const companyClient = clients.company
export const assetClient = clients.asset
export const signupRequestClient = clients.signupRequest
export const compsClient = clients.comps
export const zoneClient = clients.zone
export const localBusinessesClient = clients.localBusinesses
export const mobileClient = clients.mobile
export const tenantFinderClient = clients.tenantFinder
export const okClient = clients.okStatus
export const olvinClient = clients.olvinClient
export const parcelsClient = clients.parcels
export const alphamapClient = clients.alphamap
export const censusClient = clients.census
export const partnersClient = clients.partners
export const paymentsClient = clients.payments
export const billingClient = clients.billing

// External Clients
export const companiesClient = new CompaniesClient()
export const vendorBrandsClient = new BrandsClient()
export const devClient = clients.dev
